import React from 'react';
import { Image, View } from '@react-pdf/renderer';
import styles from './styles';

interface MapProps {
  signedMapUrl: string;
}

const Map: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<MapProps>>> = (props) => {
  const { signedMapUrl } = props;
  return (
    <View style={styles.imageContainer}>
      <Image
        src={{
          uri: signedMapUrl,
          method: 'GET',
          headers: {},
          body: '',
        }}
      />
    </View>
  );
};

export default Map;
